import styled from 'styled-components'

export const DayGroupsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
  overflow-y: auto;
`
